// extracted by mini-css-extract-plugin
export default {"close-wrapper":"ViewMore_close-wrapper__dnB89","content-wrapper":"ViewMore_content-wrapper__ZjKWR"};